// API
import { useEnv } from '../../../../../context/env-context';
// constants
import { states } from '../../../../../utils/states';
// components
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';

function ConsumerBillingAddressForm({
  btElementsEvents,
  btMetadata,
  setBtMetadata,
  useProfileAddress,
  setUseProfileAddress,
}) {
  const { envName } = useEnv();

  const handleDefaultInputChangeEvent = (fieldName, e) => {
    let { value } = e.target;

    if (fieldName === 'state') {
      value = value.toUpperCase().replace(/[^A-Z]/g, '');
    }

    if (fieldName === 'zip') {
      value = value.replace(/[^0-9]/g, '');
    }

    setBtMetadata(prevM => ({ ...prevM, [fieldName]: { value, dirty: true } }));
  };

  const getDefaultInputStyle = fieldName => {
    let className = 'bo-consumer-popover-form-menu-input';

    if (useProfileAddress) {
      className += ' bo-consumer-card-form-default-input-readonly';
    }

    if (
      (envName === 'dev' || envName === 'stage') &&
      btElementsEvents.cardNumber.changeEvent?.cardBrand === 'korean'
    ) {
      return className;
    }

    if (
      btMetadata[fieldName].dirty &&
      !btMetadata[fieldName].value &&
      fieldName !== 'addressLine2'
    ) {
      className += ' bo-consumer-card-form-default-input-invalid';
    }

    if (
      btMetadata[fieldName].dirty &&
      fieldName === 'state' &&
      !states.includes(btMetadata[fieldName].value)
    ) {
      className += ' bo-consumer-card-form-default-input-invalid';
    }

    if (
      btMetadata[fieldName].dirty &&
      fieldName === 'zip' &&
      btMetadata[fieldName].value.length !== 5
    ) {
      className += ' bo-consumer-card-form-default-input-invalid';
    }

    return className;
  };

  return (
    <>
      <Row className="mt-2">
        <Col>
          <Form.Label className="bo-consumer-popover-form-menu-label">Billing Address</Form.Label>
        </Col>
      </Row>
      <Row className="mt-2">
        <Col className="bo-same-line">
          <Form.Group className="d-flex align-items-center">
            <Form.Switch
              name="useProfileAddress"
              id="useProfileAddress"
              role="switch"
              className="bo-consumer-switch-scale"
              checked={useProfileAddress}
              onChange={e => setUseProfileAddress(e.target.checked)}
            />
            <Form.Label className="bo-consumer-popover-form-menu-label ms-3 mb-0">
              Use consumer&apos;s profile address
            </Form.Label>
          </Form.Group>
        </Col>
      </Row>
      <Row className="mt-1">
        <Col>
          <div className="mb-1">
            <Form.Label className="bo-consumer-popover-form-menu-label">Address line 1</Form.Label>
            <Form.Control
              id="addressLine1"
              className={getDefaultInputStyle('addressLine1')}
              placeholder=""
              value={btMetadata.addressLine1.value}
              onChange={e => handleDefaultInputChangeEvent('addressLine1', e)}
              readOnly={useProfileAddress}
              disabled={useProfileAddress}
            />
          </div>
          <div className="mb-1">
            <Form.Label className="bo-consumer-popover-form-menu-label">Address line 2</Form.Label>
            <Form.Control
              id="addressLine2"
              className={getDefaultInputStyle('addressLine2')}
              placeholder=""
              value={btMetadata.addressLine2.value}
              onChange={e => handleDefaultInputChangeEvent('addressLine2', e)}
              readOnly={useProfileAddress}
              disabled={useProfileAddress}
            />
          </div>
          <div className="d-flex justify-content-between mb-1">
            <div className="bo-consumer-card-form-city-input">
              <Form.Label className="bo-consumer-popover-form-menu-label">City</Form.Label>
              <Form.Control
                id="city"
                className={getDefaultInputStyle('city')}
                placeholder=""
                value={btMetadata.city.value}
                onChange={e => handleDefaultInputChangeEvent('city', e)}
                readOnly={useProfileAddress}
                disabled={useProfileAddress}
              />
            </div>
            <div className="bo-consumer-card-form-state-input">
              <Form.Label className="bo-consumer-popover-form-menu-label">State</Form.Label>
              <Form.Control
                id="state"
                className={getDefaultInputStyle('state')}
                placeholder=""
                value={btMetadata.state.value}
                maxLength={2}
                onChange={e => handleDefaultInputChangeEvent('state', e)}
                readOnly={useProfileAddress}
                disabled={useProfileAddress}
              />
            </div>
            <div className="bo-consumer-card-form-zip-input">
              <Form.Label className="bo-consumer-popover-form-menu-label">Zip</Form.Label>
              <Form.Control
                id="state"
                className={getDefaultInputStyle('zip')}
                placeholder=""
                value={btMetadata.zip.value}
                maxLength={5}
                inputMode="numeric"
                onChange={e => handleDefaultInputChangeEvent('zip', e)}
                readOnly={useProfileAddress}
                disabled={useProfileAddress}
              />
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
}

export default ConsumerBillingAddressForm;
